(ns practitest.frontend.components2.info-note
  (:require [practitest.frontend.components.icons :as icons]))

(defn mux-info-note
  "Renders an info note banner with an info icon and a message.
   Accepts a string or hiccup as `message`.
   When `on-close` is provided, renders a dismiss button on the right."
  [{:keys [message on-close]}]
  [:p.mux-info-note
   {:class (when on-close "mux-info-note--dismissible")}
   [icons/mux-info-circle]
   [:span.mux-info-note-message message]
   (when on-close
     [:button.mux-info-note-close {:on-click on-close}
      [icons/mux-close]])])
